<button
  appButton
  name="copy-gallery-link"
  location="share-gallery-dialog"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-primary"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  [share]="shareLink()?.url"
  [attr.test-share-content]="shareLink()?.url"
  (onCopied)="onLinkCopied()"
  data-test-id="copy-share-link-button"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/link.svg" size="0-5"></app-svg>
  </div>
  <span>
    @if (canShare()) {
      Share Link
    } @else {
      Copy Link
    }
  </span>
</button>

<div class="dialog-bottom-divider"></div>

<a
  appButton
  [routerLink]="['a', 'gallery', gallery().id, 'send-email']"
  name="email"
  location="share-gallery-dialog"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray-60"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/send-outline.svg" size="0-5"></app-svg>
  </div>
  <span>Email</span>
</a>

<button
  appButton
  name="embed"
  location="share-gallery-dialog"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray-60"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  (click)="openEmbedDialog()"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/code.svg" size="0-5"></app-svg>
  </div>
  <span>Embed</span>
</button>

<button
  appButton
  name="mobile-app"
  location="share-gallery-dialog"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray-60"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  (click)="openAppDialog()"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/mobile-phone.svg" size="0-5"></app-svg>
  </div>
  <span>Mobile App</span>
</button>

<button
  appButton
  name="qr-code"
  location="share-gallery-dialog"
  [hasIcon]="true"
  [verticalIcon]="true"
  color="simple-gray-60"
  height="3"
  weight="default"
  shape="large"
  size="0-5"
  (click)="openQrCodeDialog()"
>
  <div class="svg-circle">
    <app-svg src="/assets/icons/qr-code.svg" size="0-5"></app-svg>
  </div>
  <span>QR-Code</span>
</button>

<app-context-menu [options]="{ width: '240px', noSpacing: true }" verticalPosition="top" position="right">
  <button
    appButton
    contextButton
    name="social"
    location="share-gallery-dialog"
    [hasIcon]="true"
    [verticalIcon]="true"
    color="simple-gray-60"
    height="3"
    weight="default"
    shape="large"
    size="0-5"
  >
    <div class="svg-circle">
      <app-svg src="/assets/icons/dots-vertical.svg" size="0-5"></app-svg>
    </div>
    <span>Social</span>
  </button>

  <div class="button-menu" contextContent>
    <a [href]="whatsappHref()" target="_blank" rel="nofollow noreferrer noopener">
      <app-button-menu-item
        name="whatsapp"
        imageUrl="/assets/icons/logo/whatsapp-color.svg"
        location="share-gallery-dialog"
        color="simple"
        [fullWidth]="true"
      >
        WhatsApp
      </app-button-menu-item>
    </a>

    <a [href]="facebookHref()" target="_blank" rel="nofollow noreferrer noopener">
      <app-button-menu-item
        name="facebook"
        imageUrl="/assets/icons/logo/facebook-color.svg"
        location="share-gallery-dialog"
        color="simple"
        [fullWidth]="true"
      >
        Facebook
      </app-button-menu-item>
    </a>

    <a [href]="twitterHref()" target="_blank" rel="nofollow noreferrer noopener">
      <app-button-menu-item
        name="twitter"
        imageUrl="/assets/icons/logo/twitter-color.svg"
        location="share-gallery-dialog"
        color="simple"
        [fullWidth]="true"
      >
        X
      </app-button-menu-item>
    </a>

    <a [href]="linkedinHref()" target="_blank" rel="nofollow noreferrer noopener">
      <app-button-menu-item
        name="linkedin"
        imageUrl="/assets/icons/logo/linkedin-color.svg"
        location="share-gallery-dialog"
        color="simple"
        [fullWidth]="true"
      >
        LinkedIn
      </app-button-menu-item>
    </a>
  </div>
</app-context-menu>
